import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './dialog.component';
import { MyMaterialModule } from 'src/app/app.material';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [
    DialogComponent
  ],
  imports: [
    CommonModule,
    MyMaterialModule,
    FlexLayoutModule,
    TranslocoModule
  ],
  exports: [
    DialogComponent
  ]
})
export class DialogModule { }
